module.exports = __webpack_public_path__ + "public/img/calon pengawas k3 pada kapal niaga-2.1d70b5cb.png";